export default [
  {
    path: '/management/user-roles',
    name: 'user-roles',
    component: () => import('../pages/management/user-roles/user-roles.shell.vue'),
  },
  {
    path: '/management/users',
    name: 'users',
    component: () => import('../pages/management/users/users.shell.vue'),
  },
  /*
  {
    path: '/management/payment-gateways',
    name: 'payment-gateways',
    component: () => import('../pages/management/payment-gateways/payment-gateways.shell.vue'),
  },
  */
  {
    path: '/management/payment-option-groups',
    name: 'payment-option-groups',
    component: () => import('../pages/management/payment-option-groups/payment-option-groups.shell.vue'),
  },
  {
    path: '/management/property-groups',
    name: 'property-groups',
    component: () => import('../pages/management/property-groups/property-groups.shell.vue'),
  },
  /*
  {
    path: '/management/bank-accounts',
    name: 'bank-accounts',
    component: () => import('../pages/management/bank-accounts/bank-accounts.shell.vue'),
  },
  {
    path: '/management/bank-cards',
    name: 'bank-cards',
    component: () => import('../pages/management/bank-cards/bank-cards.shell.vue'),
  },
  */
  {
    path: '/management/companies',
    name: 'companies',
    component: () => import('../pages/management/companies/companies.shell.vue'),
  },
  {
    path: '/management/company-margins',
    name: 'company-margins',
    component: () => import('../pages/management/company-margins/company-margins.shell.vue'),
  },
  {
    path: '/management/markets',
    name: 'markets',
    component: () => import('../pages/management/markets/markets.shell.vue'),
  },
  {
    path: '/management/definitions/room-types',
    name: 'room-types-definition',
    component: () => import('../pages/management/definitions/room-types/room-types.shell.vue'),
  },
  {
    path: '/management/definitions/room-classes',
    name: 'room-classes-definition',
    component: () => import('../pages/management/definitions/room-classes/room-classes.shell.vue'),
  },
  {
    path: '/management/definitions/view-types',
    name: 'view-types-definition',
    component: () => import('../pages/management/definitions/view-types/view-types.shell.vue'),
  },
  {
    path: '/management/definitions/room-area-types',
    name: 'room-area-types-definition',
    component: () => import('../pages/management/definitions/room-area-types/room-area-types.shell.vue'),
  },
  {
    path: '/management/definitions/room-feature-amenities',
    name: 'room-feature-amenities-definition',
    component: () => import('../pages/management/definitions/room-feature-amenities/room-feature-amenities.shell.vue'),
  },
  {
    path: '/management/definitions/board-types',
    name: 'board-types-definition',
    component: () => import('../pages/management/definitions/board-types/board-types.shell.vue'),
  },
  {
    path: '/management/definitions/bed-types',
    name: 'bed-types-definition',
    component: () => import('../pages/management/definitions/bed-types/bed-types.shell.vue'),
  },
  {
    path: '/management/definitions/bed-sizes',
    name: 'bed-sizes-definition',
    component: () => import('../pages/management/definitions/bed-sizes/bed-sizes.shell.vue'),
  },
  {
    path: '/management/definitions/property-categories',
    name: 'property-categories-definition',
    component: () => import('../pages/management/definitions/property-categories/property-categories.shell.vue'),
  },
  {
    path: '/management/definitions/package-features',
    name: 'package-features-definition',
    component: () => import('../pages/management/definitions/package-features/package-features.shell.vue'),
  },
  {
    path: '/management/definitions/cancellation-policies',
    name: 'cancellation-policy-types-definition',
    component: () =>
      import('../pages/management/definitions/cancellation-policy-types/cancellation-policy-types.shell.vue'),
  },
  {
    path: '/management/definitions/rate-plans',
    name: 'rate-plan-types-definition',
    component: () => import('../pages/management/definitions/rate-plan-types/rate-plan-types.shell.vue'),
  },
  {
    path: '/management/integrations',
    name: 'integrations',
    component: () => import('../pages/management/integrations/integrations.shell.vue'),
  },
  /*
  {
    path: '/management/integrations/channel-managers',
    name: 'channel-managers',
    component: () => import('../pages/management/integrations/channel-managers/channel-managers.shell.vue'),
  },
  {
    path: '/management/integrations/metasearches',
    name: 'metasearches',
    component: () => import('../pages/management/integrations/metasearches/metasearches.shell.vue'),
  },
  {
    path: '/management/integrations/otas',
    name: 'otas',
    component: () => import('../pages/management/integrations/otas/otas.shell.vue'),
  },
  */
  {
    path: '/management/email-providers',
    name: 'email-providers',
    component: () => import('../pages/management/email-providers/email-providers.shell.vue'),
  },
];
